import { ColorItem, Maybe } from '@/types/graphql.prod';
import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';
import classes from './customizeOptions.module.css';

export const CustomizeOptions = ({
  colorOptions,
  allColorCount,
  selectedColor,
  setSelectedColor,
  outOfStock,
  url_key,
}: {
  colorOptions: Maybe<ColorItem>[];
  allColorCount: number;
  selectedColor: Maybe<ColorItem> | undefined;
  setSelectedColor: Dispatch<SetStateAction<Maybe<ColorItem> | undefined>>;
  outOfStock: boolean | undefined;
  url_key: string;
}) => {
  const handleClick = (value: ColorItem) => {
    setSelectedColor(value);
  };

  return (
    <div
      className='mb-[10px] flex items-center'
      style={{
        opacity: outOfStock ? 0.5 : 1,
      }}
    >
      <ul className={classes.items}>
        {colorOptions.map((value, index) => {
          const image = value?.image;
          const hover_image = value?.hover_image;

          if (!hover_image) return null;

          const itemClass = selectedColor?.image === image ? classes.activeItem : classes.item;

          return (
            <div
              aria-hidden='true'
              className={itemClass}
              key={index}
              onClick={e => {
                e.preventDefault();

                if (value) {
                  handleClick(value);
                }
              }}
            >
              <Image
                src={hover_image}
                width={80}
                height={80}
                alt=''
                quality={90}
                className='h-auto w-full'
              />
            </div>
          );
        })}
      </ul>
      {allColorCount && allColorCount > 3 && (
        <span className='ml-[8px] font-sans text-sm leading-[1.4] text-[#666] lg_hidden'>{`+${allColorCount - 3}`}</span>
      )}
      {allColorCount && (
        <span className='ml-[10px] hidden font-sans text-sm leading-[1.4] text-[#666] lg_inline'>
          {`${allColorCount} Color${allColorCount > 1 ? 's' : ''}`}
        </span>
      )}
    </div>
  );
};
